import {UmpireTransmissionProvider} from '../umpire-transmission-provider';
import {UmpireIncident} from '../umpire-incident';
import {UmpireSquad} from '../umpire-squad';
import {UmpireArticle} from '../umpire-article';
import {UmpireRound} from '../umpire-round';
import {UmpireVenue} from '../umpire-venue';
import {MatchStatusEnum} from './umpire-match-status-enum';

export interface UmpireMatch {
  type: string;

  id: string;

  start_time: string | undefined;

  is_postponed: boolean;

  postponed_start_time: string | null;

  home_squad: UmpireSquad;

  away_squad: UmpireSquad;

  highlights_url: string | undefined;

  match_report_url: string | undefined;

  incidents: UmpireIncident[];

  transmission_providers: UmpireTransmissionProvider[];

  article: UmpireArticle;

  round: UmpireRound;

  relationshipNames: string[];

  fun_facts: string[];

  slug: string | null;

  venue: UmpireVenue;

  status: MatchStatusEnum;

  away_squad_score: string | null;

  home_squad_score: string | null;

  ticket_counter: {
    external_url: string | null;
    show_counter: boolean;
    pool: number;
    sold: number;
  };
}
